import { remainingIn } from "../lib/recovery";

interface RecoveryCountdownProps {
  /** When the thing was deleted, or null if it was not. */
  deletedAt: string | null | undefined;
}

/**
 * How long a deleted thing has left, in the words every Deleted listing uses
 * (ADR 000055).
 *
 * One component rather than a call per screen because the copies drifted. Two
 * of the listings never showed the clock at all and a third styled it its own
 * way, so the same thirty days read as a deadline on some screens and as an
 * archive on others (issue #296). An archive is somewhere you can come back to,
 * which is the one thing this window is not.
 *
 * Renders nothing for something that was never deleted, so a caller can hand it
 * a row from either side of the window without a guard of its own.
 */
export function RecoveryCountdown({ deletedAt }: RecoveryCountdownProps) {
  const left = remainingIn(deletedAt);
  if (!left) return null;

  return (
    <span className={left.urgent ? "recovery-left is-urgent" : "recovery-left"}>
      {/* Past the window the sweep has not reached it yet, and "0 days left"
          would read as something still worth clicking Restore on. */}
      {left.expired ? "Being removed any moment now" : left.label}
    </span>
  );
}
